var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reminder-wrapper",on:{"click":_vm.check}},[_c('RemainingDays',{staticClass:"reminder",attrs:{"data":_vm.selectedData}}),_c('RemainingBudget',{staticClass:"reminder",attrs:{"data":_vm.selectedData}}),_c('TodayBuying',{staticClass:"reminder",attrs:{"data":_vm.selectedData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }